import { useState } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { API_URL } from "../config";
import { mapArchivedEmployee } from "../utils/employeeMapper";
import { getCached } from "../utils/employeeCache";

// Archived employees list + count
export const useArchivedEmployees = ({ profile, language }) => {
  const [archivedEmployees, setArchivedEmployees] = useState([]);
  // State for archived employee count
  const [archivedCount, setArchivedCount] = useState(0);

  // Function to fetch archived employees.
  // `forceRefresh` bypasses the cache — pass true right after a restore so
  // this list is never left stale.
  const fetchArchivedEmployees = async (forceRefresh = false) => {
    try {
      // Get client name from localStorage
      const clientName = profile?.clientName || localStorage.getItem("clientName");

      // Make API call to get all archived employees (cached)
      console.log("📡 Fetching all archived employees");
      const archivedData = await getCached(
        "manager-archived-employees",
        async () => {
          const response = await apiFetch(`${API_URL}/employees/archived`, { method: "GET" });
          const archivedJson = await response.json();
          return archivedJson.employees || archivedJson;
        },
        { force: forceRefresh }
      );

      console.log(`✅ Received ${archivedData.length} archived employees`);

      // FIXED: Filter on frontend based on client name
      let filteredArchivedData = archivedData;

      if (clientName && clientName.toLowerCase() !== "infinity") {
        // Filter for specific client
        console.log(
          `🔍 Filtering archived employees for client: ${clientName}`
        );
        filteredArchivedData = archivedData.filter(
          (emp) => emp.clientName?.toLowerCase() === clientName.toLowerCase()
        );
        console.log(
          `✅ Filtered to ${filteredArchivedData.length} archived employees for ${clientName}`
        );
      }

      // Map archived employees with proper formatting
      const mappedArchivedEmployees = filteredArchivedData.map((emp) =>
        mapArchivedEmployee(emp, language)
      );

      // Update archived employees state
      setArchivedEmployees(mappedArchivedEmployees || []);
      // Update archived count
      setArchivedCount(mappedArchivedEmployees?.length || 0);

      console.log(
        `✅ Successfully mapped ${mappedArchivedEmployees.length} archived employees`
      );
    } catch (err) {
      // Log error - don't show error message as endpoint might not exist
      console.error("❌ Failed to fetch archived employees:", err);
      console.error("Error response:", err.response?.data);
      console.error("Error status:", err.response?.status);
      // Set empty array if endpoint doesn't exist
      setArchivedEmployees([]);
      setArchivedCount(0);
    }
  };

  return {
    archivedEmployees,
    setArchivedEmployees,
    archivedCount,
    setArchivedCount,
    fetchArchivedEmployees,
  };
};
